import { useMemo } from 'react';
import useSWR from 'swr';
import { swrKeys } from '@shared/api/swr/keys';
import { mapInvoiceDtoToEntity } from '@entities/invoice';
import type { InvoiceDto } from '@shared/api/contracts';

export const useInvoiceDetail = (id: string | null) => {
  const { data, error, isLoading, mutate } = useSWR<InvoiceDto>(
    id ? swrKeys.invoices.byId(id) : null
  );

  const invoice = useMemo(() => (data ? mapInvoiceDtoToEntity(data) : null), [data]);

  return {
    invoice,
    isLoading: Boolean(id) && isLoading,
    error,
    mutate,
  };
};
